const {TRIAL_TYPE} = require("../config");

exports.API_URL = 'https://api2.comprasocial.me/';

exports.ADD_EMAIL_VERIFICATION_ENDPOINT = 'email/addEmailVerificationTrial';
exports.VERIFY_EMAIL_VERIFICATION_ENDPOINT = 'email/verifyEmailTrial';
exports.TRIAL_GET_SPECIAL_OFFERS_ENDPOINT = 'trial/getSpecialOffers';
exports.EXEC_TRIAL_ENDPOINT = 'trial/execTrial';
exports.ADDED_SPECIAL_OFFERS_ENDPOINT = 'trial/addedSpecialOfferProduct';
exports.TK_USER_ENDPOINT = 'tiktok/user';

exports.getTkUserRequestBody = function(username){
    return {user: username}
}

exports.getTrialRequestBody = function(uid, email, username, currentLanguage){
    return {
        userID: uid,
        email: email,
        username: username,
        trialType: TRIAL_TYPE,
        lang: currentLanguage
    }
}

exports.getEmailVerificationRequestBody = function(uid, email, emailCode ){
    return {
        userID: uid,
        email: email,
        trialType: TRIAL_TYPE,
        code: emailCode
    }
}

exports.DEFAULT_HEADER = {headers: {"Content-Type": "application/json"}};

